module.exports = __webpack_public_path__ + "static/media/tds-account.3780da73.png";